import axios from 'axios'

import { createAsyncThunk } from '@reduxjs/toolkit'

const baseUrl = import.meta.env.VITE_API_BASE_URL

const api = axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
})

export const getQuestions = createAsyncThunk('questions/get', async () => {
  try {
    const response = await api.get('v1/questions')

    return response.data
  } catch (error) {
    console.error(error)
  }
})

export const getAnswer = createAsyncThunk('answer/get', async (id: number) => {
  try {
    const response = await api.get(`v1/variants/${id}`)

    return response.data
  } catch (error) {
    console.error(error)
  }
})

export const createResult = createAsyncThunk(
  'results/post',
  async ({ corrects, questions }: { corrects: number; questions: number }) => {
    try {
      const response = await api.post(`v1/results`, { corrects, questions })

      return response.data
    } catch (error) {
      console.error(error)
    }
  },
)

export const getResult = createAsyncThunk('results/get', async (id: number) => {
  try {
    const response = await api.get(`v1/results/${id}`)
    return response.data
  } catch (error) {
    console.error(error)
    window.location.href = '/*'
  }
})
